import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top on internal route (pathname) changes so a new page
// never opens partway down. Runs in a layout effect so there is no visible jump.
// With a hash (e.g. /perspective#perspective-notes) it scrolls to that section once it
// has rendered, so links such as the footer's "Field Notes" land on the right heading.
export const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useLayoutEffect(() => {
        if (hash) {
            const id = decodeURIComponent(hash.slice(1));
            let tries = 0;
            const seek = () => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView();
                else if (tries++ < 20) setTimeout(seek, 50);
            };
            requestAnimationFrame(seek);
            return;
        }
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};
